module.exports = __webpack_public_path__ + "img/pic_3.6fd2d8c6.png";